import { render, staticRenderFns } from "./ASC_ByPatientType.vue?vue&type=template&id=661c80b1&scoped=true&"
import script from "./ASC_ByPatientType.vue?vue&type=script&lang=js&"
export * from "./ASC_ByPatientType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661c80b1",
  null
  
)

export default component.exports